export enum MentionInsightTypes {
    INTELLIGENT_SUMMARY = 'INTELLIGENT_SUMMARY',
    CONTEXTUAL_ANALYSIS = 'CONTEXTUAL_ANALYSIS',
    SENTIMENT_OPINION = 'SENTIMENT_OPINION',
    SENTIMENT_OPINION_WITH_KEYWORDS = 'SENTIMENT_OPINION_WITH_KEYWORDS',
    MENTION_CHARACTERIZATION = 'MENTION_CHARACTERIZATION',
    LIKELY_AUDIENCE = 'LIKELY_AUDIENCE',
    BRANDS_MENTIONED = 'BRANDS_MENTIONED',
    PEOPLE_MENTIONED = 'PEOPLE_MENTIONED',
    PLACES_MENTIONED = 'PLACES_MENTIONED',
    KEY_FACTS_AND_FIGURES = 'KEY_FACTS_AND_FIGURES',
    QUOTES = 'QUOTES',
    QUOTES_ATTRIBUTION = 'QUOTES_ATTRIBUTION',
    BRANDS_PEOPLE_PLACES_MENTIONED_FURTHER = 'BRANDS_PEOPLE_PLACES_MENTIONED_FURTHER',
    MENTION_CHARACTERIZATION_FURTHER_EMOTION = 'MENTION_CHARACTERIZATION_FURTHER_EMOTION',
    MENTION_CHARACTERIZATION_FURTHER_WORD = 'MENTION_CHARACTERIZATION_FURTHER_WORD',
    CUSTOM = 'CUSTOM',
    AD_HOC_CUSTOM = 'AD_HOC_CUSTOM'
}
